// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AmazonOutlinedSvg from "@ant-design/icons-svg/es/asn/AmazonOutlined";
import AntdIcon from '../components/AntdIcon';

var AmazonOutlined = function AmazonOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AmazonOutlinedSvg
  }));
};

AmazonOutlined.displayName = 'AmazonOutlined';
export default React.forwardRef(AmazonOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AmazonOutlined.js
// module id = 559
// module chunks = 0